export default "__VITE_ASSET__B5D5iSI___"